import React, { createContext } from 'react';
import { useCurrencyQuery } from './hooks/useCurrencyQuery';
import { defaultCurrencySettings } from './reducers/product-management';

export type Currency = (typeof defaultCurrencySettings)['currency'];

// Keep the original API exactly the same
type CurrencyContextValue = {
  currency: Currency | null;
  refetch: () => void;
};

const CurrencyContext = createContext<CurrencyContextValue | null>(null);

export function CurrencyProvider({ children }: { children: React.ReactNode }) {
  // Use React Query data directly
  const queryResult = useCurrencyQuery();

  // Create the context value directly from query results
  const value = {
    currency: queryResult.data ?? null,
    refetch: queryResult.refetch,
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency(): CurrencyContextValue {
  const currency = React.useContext(CurrencyContext);
  if (!currency) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return currency;
}
